import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, CircularProgress } from '@material-ui/core';

class FHEContainerForm extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        children: PropTypes.node,
        onRender: PropTypes.func,
        loading: PropTypes.bool,
        withoutPadding: PropTypes.bool
    };

    static defaultProps = {
        withoutPadding: false,
        loading: false,
        onRender: null,
        children: null
    };

    renderLoading = () => {
        const { classes } = this.props;
        return (
            <div className={classes.loadingContainer}>
                <CircularProgress />
            </div>
        );
    };

    render() {
        const { children, classes, loading, onRender, withoutPadding } = this.props;
        return (
            <div className={`${!withoutPadding ? classes.containerPadding : ''} ${classes.container}`}>
                {loading ? this.renderLoading() : onRender ? onRender() : children}
            </div>
        );
    }
}

const styles = () => ({
    containerPadding: {
        padding: '12px 24px'
    },
    container: {
        width: '100%'
    },
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withStyles(styles, { withTheme: true })(FHEContainerForm);



// WEBPACK FOOTER //
// ./data/components/FHEContainerForm.js